<template>
  <div
    :class="[
      'base-loading-container',
      {
        fullscreen: fullscreen,
      },
    ]"
  >
    <div :class="['content', { 'is-loading': isLoading }]">
      <slot></slot>
    </div>

    <div v-if="isLoading" class="base-loading">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLoading',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.base-loading-container.fullscreen {
  position: relative;
  width: 100dvw;
  height: 100dvh;
}

.base-loading-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.base-loading {
  display: flex;
  align-items: center;

  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.spinner {
  margin: 0 auto;
  width: 70px;
  text-align: center;
  display: flex;
  gap: 8px;

  > div {
    width: 18px;
    height: 18px;
    background-color: #ee4d2d;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }

  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.content.is-loading {
  opacity: 0.65;
  transition: all 2s ease-in-out;
}
</style>
